export const actions = {
    CUSTOM_DOMAINS: 'groove_custom_domains',
    SUB_DOMAINS: 'groove_can_use_subdomains',
    PREMIUM_TEMPLATES: 'groovepages_has_premium_templates',
    TOTAL_PAGES: 'groovepages_total_pages',
    INTEGRATIONS: 'groove_can_use_integrations',
    WEBHOOKS: 'groove_can_use_webhooks',
    SHARE_FUNNELS: 'groovepages_can_share_funnels',
    IMPORT_FUNNELS: 'groovepages_can_import_shared_funnels',
    EXPORT_SITES: 'groovepages_can_export_sites',
    BRANDED_PAGES: 'groove_branding_on_assets',
    CUSTOM_EMBEDS: 'groovepages_can_add_custom_embeds',
    SOURCE_CODE: 'groovepages_has_source_code_button',
    TOTAL_SITES: 'groove_projects'
};

export const hasPermission = (action, permissions) => {
    if (!permissions[action]) return false;
    return JSON.parse(permissions[action]);
};